const SubsectionStyles = {
  theme_syngenta_new: {
    "--main_color": "#00004B",
    "--main_logo": "NKcropwise01.png",
    "--main_logo_height":"auto",
    "--main_logo_margin":"-5px 80px",
    "--frame_logo": "cropwise-logo.png", 
    "--footer_logo": "NKcropwise01.png", 
    "--main_background_image": "",
    "--button_success": "#8BD683",
    "--openApp_btn": "#8BD683",
    "--openApp_btn_text": "#171B27",
    "--openApp_btn_borderRadius": "0",
    "--openApp_btn_position_btm": "-175px",
    "--font_family": "",
    "--header_color": "#fff",
    "--header_boxshadow": "0 0 2px rgba(0, 0, 0, 0.15)",
    "--header_border": "solid 1px #d5d9df",
    "--header_padding": "14px 1rem",
    "--logout_icon": "logout-icon-new.png",
    "--logout_display": 'none',
    "--wlcm_display": 'flex',
    "--wlcm_display_dir": 'row-reverse',
    "--logout_btn_border_left": "none",
    "--logout_btn_border_right": 'solid 2px #dde5ee',
    "--logout_btn_margin_right": '10px',
    "--logout_btn_height": '45px',
    "--wlcm_label_margin": '2px 0 0 0',
    "--wlcm_label_bg": '#f3f4f6',
    "--wlcm_label_border": 'solid 1px #dfe2e7',
    "--wlcm_label_display": 'block',
    "--card_border": "solid 1px #eaeaea",
    "--tooltip_color": "#00558c",
    "--openApp_btn_fontweight": "500",
    "--btn_position": "53px",
    "--btn_transform": "translateX(-50%)",
    "--card_width": "450px",
    "--card_bg": "#fff",
    "--card_h3_color": "#00004B",
    "--arrow_display": "none",
    "--bullets_bg": "#b9c1c8",
    "--body_border": "0",
    "--card_shadow": " 0 0 3px rgba(0, 0, 0, 0.1)",
    "--card_border-radius": '4px',
    "--card_padding": "0 1rem 1rem",
    "--card_height": "auto",
    "--glide-margin-top":"3% ",
    "--cards_gap": 20,
    "--card_image_height": "166px",
    "--card_image_width": "auto",
    "--card_image_position": "relative",
    "--card_image_position_top": "18%",
    "--footer_color": "#00004B",
    "--cookiePolicy_color": "#0078cd",
    "--arrow_image": "",
    "--card_color": "#000",
    "--page_title": "NK Cropwise",
    "--card_h3_margin": "-1.5rem",
    "--card_p_margin": "0 -25px",
    "--nav_bg_color": "#00004b",
    "--nav_icon": "block",
    "--nav_btn_icons": "brightness(0) invert(1)",
    "--nav_display": 'block',
    "--logo_display": 'initial',
    "--card_logo_display": 'none',
    "--glide_margin": '70px',
    "--nav_height": 'calc(100vh)',
    "--nav_height_mobile": 'calc(calc(var(--vh, 1vh) * 100))',
    "--nav_position": "0",
    "--header_zindex": '1',
    "--header_h1_margin": '60px',
    "--nav_btn_color":"#fff",
    "--breakpoints": {
      850: { perView: 3 },
      1000: { perView: 4 },
      1200: { perView: 3 },
      1500: { perView: 5 },
      2400: { perView: 6 },
      3200: { perView: 15 },
    },
    "--glide_display":"inline-block",
    "--slide_float":"left",
    "--glide_marginTop":"20px",
    "--card_marginLeftFirst":"10px",
    "--card_marginBottom":"20px",
    "--min_ind_float":"right",
    "--card_display":"flex",
    "--card_flex-dir":"column-reverse",
    "--slide_text-height":"55px",
    "--slide_text-height-mobile":"55px",
    "--card_p_display":"0",
    "--slide_height":"auto",
    "--btn_display":"none",
    "--slide_hover_img_filter":"brightness(0) invert(1)",
    "--slide_hover_display":"block",
    "--bullets_keyboard":false,
    "--footer-font_weight":"bold",
    "--pages_height":"auto",
    "--body_overflow":"auto",
    "--footer_position":"initial",
    "--footer_position_mobile":"initial"
  },
  theme_syngenta: {
    "--main_color": "#00004B",
    "--main_logo": "NKcropwise01.png",
    "--main_logo_height":"auto",
    "--main_logo_margin":"-5px 80px",
    "--frame_logo": "cropwise-logo.png", 
    "--footer_logo": "NKcropwise01.png", 
    "--main_background_image": "",
    "--button_success": "#19a04b",
    "--openApp_btn": "#14803C",
    "--openApp_btn_text": "#fff",
    "--openApp_btn_borderRadius": "4px",
    "--openApp_btn_position_btm": "-130px",
    "--font_family": "",
    "--header_color": "#fff",
    "--header_boxshadow": "0 0 2px rgba(0, 0, 0, 0.15)",
    "--header_border": "solid 1px #d5d9df",
    "--header_padding": "14px 1rem",
    "--logout_icon": "logout-icon-new.png",
    "--logout_display": 'none',
    "--wlcm_display": 'flex',
    "--wlcm_display_dir": 'row-reverse',
    "--logout_btn_border_left": "none",
    "--logout_btn_border_right": 'solid 2px #dde5ee',
    "--logout_btn_margin_right": '10px',
    "--logout_btn_height": '45px',
    "--wlcm_label_margin": '2px 0 0 0',
    "--wlcm_label_bg": '#f3f4f6',
    "--wlcm_label_border": 'solid 1px #dfe2e7',
    "--wlcm_label_display": 'block',
    "--card_border": "solid 1px #eaeaea",
    "--tooltip_color": "#00558c",
    "--openApp_btn_fontweight": "normal",
    "--btn_position": "50%",
    "--btn_transform": "translateX(-50%)",
    "--card_width": "350px",
    "--card_bg": "#fff",
    "--card_h3_color": "#00004B",
    "--arrow_display": "none",
    "--bullets_bg": "#b9c1c8",
    "--body_border": "0",
    "--card_shadow": " 0 0 3px rgba(0, 0, 0, 0.1)",
    "--card_border-radius": '4px',
    "--card_padding": "1.5rem 1rem 1rem",
    "--card_height": "430px",
    "--glide-margin-top":"9% ",
    "--cards_gap": 20,
    "--card_image_height": "120px",
    "--card_image_width": "90%",
    "--card_image_position": "absolute",
    "--card_image_position_top": "18%",
    "--footer_color": "#00004B",
    "--cookiePolicy_color": "#0078cd",
    "--arrow_image": "",
    "--card_color": "#000",
    "--page_title": "NK Cropwise",
    "--card_h3_margin": "-1.5rem",
    "--card_p_margin": "150px -24px 0 -24px",
    "--nav_bg_color": "#00004b",
    "--nav_icon": "block",
    "--nav_btn_icons": "brightness(0) invert(1)",
    "--nav_display": 'block',
    "--logo_display": 'initial',
    "--card_logo_display": 'none',
    "--glide_margin": '70px',
    "--nav_height": 'calc(100vh)',
    "--nav_height_mobile": 'calc(calc(var(--vh, 1vh) * 100))',
    "--nav_position": "0",
    "--header_zindex": '1',
    "--header_h1_margin": '60px',
    "--nav_btn_color":"#fff",
    "--breakpoints": {
      850: { perView: 3 },
      1000: { perView: 4 },
      1200: { perView: 3 },
      1500: { perView: 5 },
      2400: { perView: 6 },
      3200: { perView: 15 },
    },
    "--glide_display":"flex",
    "--slide_float":"none",
    "--glide_marginTop":"45px",
    "--card_marginLeftFirst":"0",
    "--card_marginBottom":"0",
    "--min_ind_float":"left",
    "--card_display":"block",
    "--card_flex-dir":"inherit",
    "--slide_text-height":"328px",
    "--slide_text-height-mobile":"265px",
    "--card_p_display":"1",
    "--slide_height":"500px",
    "--btn_display":"block",
    "--slide_hover_img_filter":"none",
    "--slide_hover_display":"block",
    "--bullets_keyboard":true,
    "--footer-font_weight":"normal",
    "--pages_height":"calc(var(--vh, 1vh) * 100)",
    "--body_overflow":"hidden",
    "--footer_position":"fixed",
    "--footer_position_mobile":"absolute"
  },
  theme_syngenta_old: {
    "--main_color": "#00004B",
    "--main_logo": "cropwise-logo.png",
    "--main_logo_height":"45px",
    "--main_logo_margin":"unset",
    "--frame_logo": "cropwise-logo.png",
    "--footer_logo": "cropwise-logo.png", 
    "--main_background_image": "",
    "--button_success": "#19a04b",
    "--openApp_btn": "#19a04b",
    "--openApp_btn_text": "#fff",
    "--openApp_btn_borderRadius": "30px",
    "--openApp_btn_position_btm": "20px",
    "--font_family": "",
    "--header_color": "#fff",
    "--header_boxshadow": "0 0 2px rgba(0, 0, 0, 0.15)",
    "--header_border": "solid 1px #d5d9df",
    "--header_padding": "14px 1rem",
    "--logout_icon": "logout-icon.png",
    "--logout_display": 'inline-block',
    "--wlcm_display": 'flex',
    "--wlcm_display_dir": 'unset',
    "--logout_btn_border_left": "solid 2px #dde5ee",
    "--logout_btn_border_right": 'none',
    "--logout_btn_margin_right": '10px',
    "--logout_btn_height": '30px',
    "--wlcm_label_margin": '13px 10px 0 0',
    "--wlcm_label_bg": 'transparent',
    "--wlcm_label_border": 'none',
    "--wlcm_label_display": 'contents',
    "--card_border": "solid 1px #eaeaea",
    "--tooltip_color": "#00558c",
    "--openApp_btn_fontweight": "normal",
    "--btn_position": "50%",
    "--btn_transform": "translateX(-50%)",
    "--card_bg": "#fff",
    "--card_h3_color": "#000",
    "--card_width": "300px",
    "--arrow_display": "none",
    "--bullets_bg": "#b9c1c8",
    "--body_border": "0",
    "--card_shadow": " 0 0 3px rgba(0, 0, 0, 0.1)",
    "--card_border-radius": '0',
    "--card_padding": "0",
    "--card_height": "430px",
    "--glide-margin-top":"9% ",
    "--cards_gap": 20,
    "--footer_color": "#0078cd",
    "--cookiePolicy_color": "#0078cd",
    "--arrow_image": "",
    "--card_color": "#00004B",
    "--page_title": "Cropwise Seed Selector",
    "--nav_bg_color": "#fff",
    "--nav_icon": "none",
    "--nav_btn_icons": "none",
    "--nav_display": 'none',
    "--logo_display": 'initial',
    "--card_logo_display": 'initial',
    "--glide_margin": '0',
    "--nav_height": 'calc(100vh - 75px)',
    "--nav_height_mobile": 'calc(calc(var(--vh, 1vh) * 100) - 75px)',
    "--nav_position": "75px",
    "--header_zindex": '1111',
    "--header_h1_margin": '20px',
    "--nav_btn_color": "#00004B",
    "--breakpoints": {
      850: { perView: 3 },
      1000: { perView: 4 },
      1200: { perView: 5 },
      1500: { perView: 7 },
      2400: { perView: 15 },
      3200: { perView: 15 },
    },
    "--glide_display":"flex",
    "--slide_float":"none",
    "--glide_marginTop":"45px",
    "--card_marginLeftFirst":"0",
    "--card_marginBottom":"0",
    "--min_ind_float":"left",
    "--card_display":"block",
    "--card_flex-dir":"inherit",
    "--slide_text-height":"328px",
    "--slide_text-height-mobile":"265px",
    "--card_p_display":"1",
    "--slide_height":"500px",
    "--btn_display":"block",
    "--slide_hover_img_filter":"none",
    "--slide_hover_display":"block",
    "--bullets_keyboard":true,
    "--footer-font_weight":"normal",
    "--pages_height":"calc(var(--vh, 1vh) * 100)",
    "--body_overflow":"hidden",
    "--footer_position":"fixed",
    "--footer_position_mobile":"absolute"
  },
  theme_growmark: {
    "--main_color": "#000000",
    "--main_logo": "GrowmarkFSLogo.png",
    "--main_logo_height":"45px",
    "--main_logo_margin":"unset",
    "--frame_logo": "GrowmarkFSLogo.png",
    "--footer_logo": "GrowmarkFSLogo.png", 
    "--main_background_image": "white-label-bg.png",
    "--button_success": "#d50032",
    "--openApp_btn": "transparent",
    "--openApp_btn_text": "#000",
    "--openApp_btn_borderRadius": "30px",
    "--openApp_btn_position_btm": "20px",
    "--font_family": "lato, sans-serif",
    "--header_color": "transparent",
    "--header_text_color": "#000",
    "--header_boxshadow": "none",
    "--header_border": "0",
    "--header_padding": "30px 3rem",
    "--logout_icon": "logout-icon-wt.png",
    "--logout_display": 'inline-block',
    "--wlcm_display": 'flex',
    "--wlcm_display_dir": 'unset',
    "--logout_btn_border_left": "solid 2px #D7DAE0",
    "--logout_btn_border_right": 'none',
    "--logout_btn_margin_right": '10px',
    "--logout_btn_height": '30px',
    "--wlcm_label_margin": '13px 10px 0 0',
    "--wlcm_label_bg": 'transparent',
    "--wlcm_label_border": 'none',
    "--wlcm_label_display": 'contents',
    "--card_border": "0",
    "--tooltip_color": "#000",
    "--openApp_btn_fontweight": "bold",
    "--btn_position": "0",
    "--btn_transform": "none",
    "--card_bg": "rgba(255,255,255,.9)",
    "--card_h3_color": "#000",
    "--card_width": "300px",
    "--arrow_display": "inline-block",
    "--bullets_bg": "#D7DAE0",
    "--body_border": "solid 18px #F1002C",
    "--card_shadow": "0 1px 22px rgba(0, 0, 0, 0.5)",
    "--card_border-radius": '0',
    "--card_padding": "0",
    "--card_height": "455px",
    "--glide-margin-top":"9% ",
    "--cards_gap": 50,
    "--card_image_height": "170px",
    "--card_image_width": "100%",
    "--card_image_position": "relative",
    "--card_image_position_top": "0",
    "--footer_color": "#fff",
    "--cookiePolicy_color": "#0078cd",
    "--arrow_image": "red-arrow.png",
    "--card_color": "#000",
    "--page_title": "Cropwise Seed Selector",
    "--card_h3_margin": "0",
    "--card_p_margin": "0",
    "--nav_bg_color": "#fff",
    "--nav_icon": "none",
    "--nav_btn_icons": "none",
    "--nav_display": 'none',
    "--logo_display": 'initial',
    "--card_logo_display": 'initial',
    "--glide_margin": '0',
    "--nav_height": 'calc(100vh - 75px)',
    "--nav_height_mobile": 'calc(calc(var(--vh, 1vh) * 100) - 75px)',
    "--nav_position": "75px",
    "--header_zindex": '1111',
    "--header_h1_margin": '20px',
    "--nav_btn_color": "#000000",
    "--breakpoints": {
      850: { perView: 3 },
      1000: { perView: 4 },
      1200: { perView: 5 },
      1500: { perView: 7 },
      2400: { perView: 15 },
      3200: { perView: 15 },
    },
    "--glide_display":"flex",
    "--slide_float":"none",
    "--glide_marginTop":"45px",
    "--card_marginLeftFirst":"0",
    "--card_marginBottom":"0",
    "--min_ind_float":"left",
    "--card_display":"block",
    "--card_flex-dir":"inherit",
    "--slide_text-height":"328px",
    "--slide_text-height-mobile":"265px",
    "--card_p_display":"1",
    "--slide_height":"500px",
    "--btn_display":"block",
    "--slide_hover_img_filter":"none",
    "--slide_hover_display":"block",
    "--bullets_keyboard":true,
    "--footer-font_weight":"normal",
    "--pages_height":"calc(var(--vh, 1vh) * 100)",
    "--body_overflow":"hidden",
    "--footer_position":"fixed",
    "--footer_position_mobile":"absolute"
  },
  theme_winfield: {
    "--main_color": "#000",
    "--main_logo":"whiteSyngentaLogo.png",
    "--main_logo_height":"45px",
    "--main_logo_margin":"unset",
    "--frame_logo": "Syngenta-logo.png",
    "--footer_logo": "NKcropwise01.png", 
    "--main_background_image": "winfield-bg.png",
    "--button_success": "#0C3D55",
    "--openApp_btn": "transparent",
    "--openApp_btn_text": "#0C3D55",
    "--openApp_btn_borderRadius": "30px",
    "--openApp_btn_position_btm": "20px",
    "--font_family": "lato, sans-serif",
    "--header_color": "transparent",
    "--header_text_color": "#fff",
    "--header_boxshadow": "none",
    "--header_border": "0",
    "--header_padding": "30px 3rem",
    "--logout_icon": "logout-icon-gm.png",
    "--logout_display": 'inline-block',
    "--wlcm_display": 'flex',
    "--wlcm_display_dir": 'unset',
    "--logout_btn_border_left": "solid 2px #D7DAE0",
    "--logout_btn_border_right": 'none',
    "--logout_btn_margin_right": '10px',
    "--logout_btn_height": '30px',
    "--wlcm_label_margin": '13px 10px 0 0',
    "--wlcm_label_bg": 'transparent',
    "--wlcm_label_border": 'none',
    "--wlcm_label_display": 'contents',
    "--card_border": "0",
    "--tooltip_color": "#000",
    "--openApp_btn_fontweight": "bold",
    "--btn_position": "0",
    "--btn_transform": "none",
    "--card_bg": "rgba(255,255,255,.9)",
    "--card_h3_color": "#000",
    "--card_width": "300px",
    "--arrow_display": "inline-block",
    "--bullets_bg": "#fff",
    "--body_border": "0",
    "--card_shadow": "0 1px 22px rgba(0, 0, 0, 0.5)",
    "--card_border-radius": '0',
    "--card_padding": "0",
    "--card_height": "455px",
    "--glide-margin-top":"9% ",
    "--cards_gap": 50,
    "--card_image_height": "170px",
    "--card_image_width": "100%",
    "--card_image_position": "relative",
    "--card_image_position_top": "0",
    "--arrow_filter": "grayscale(1)",
    "--footer_color": "#fff",
    "--cookiePolicy_color": "#0078cd",
    "--arrow_image": "grey-arrow.png",
    "--card_color": "#000",
    "--page_title": "Cropwise Seed Selector",
    "--card_h3_margin": "0",
    "--card_p_margin": "0",
    "--nav_bg_color": "#fff",
    "--nav_icon": "none",
    "--nav_btn_icons": "none",
    "--nav_display": 'none',
    "--logo_display": 'initial',
    "--card_logo_display": 'initial',
    "--glide_margin": '0',
    "--nav_height": 'calc(100vh - 75px)',
    "--nav_height_mobile": 'calc(calc(var(--vh, 1vh) * 100) - 75px)',
    "--nav_position": "75px",
    "--header_zindex": '1111',
    "--header_h1_margin": '20px',
    "--nav_btn_color": "#000",
    "--breakpoints": {
      850: { perView: 3 },
      1000: { perView: 4 },
      1200: { perView: 5 },
      1500: { perView: 7 },
      2400: { perView: 15 },
      3200: { perView: 15 },
    },
    "--glide_display":"flex",
    "--slide_float":"none",
    "--glide_marginTop":"45px",
    "--card_marginLeftFirst":"0",
    "--card_marginBottom":"0",
    "--min_ind_float":"left",
    "--card_display":"block",
    "--card_flex-dir":"inherit",
    "--slide_text-height":"328px",
    "--slide_text-height-mobile":"265px",
    "--card_p_display":"1",
    "--slide_height":"500px",
    "--btn_display":"block",
    "--slide_hover_img_filter":"none",
    "--slide_hover_display":"block",
    "--bullets_keyboard":true,
    "--footer-font_weight":"normal",
    "--pages_height":"calc(var(--vh, 1vh) * 100)",
    "--body_overflow":"hidden",
    "--footer_position":"fixed",
    "--footer_position_mobile":"absolute"
  },
  theme_paplus: {
    "--main_color": "#000",
    "--main_logo":"whiteSyngentaLogo.png",
    "--main_logo_height":"45px",
    "--main_logo_margin":"unset",
    "--frame_logo": "Syngenta-logo.png",
    "--footer_logo": "NKcropwise01.png", 
    "--main_background_image": "winfield-bg.png",
    "--button_success": "#0C3D55",
    "--openApp_btn": "transparent",
    "--openApp_btn_text": "#0C3D55",
    "--openApp_btn_borderRadius": "30px",
    "--openApp_btn_position_btm": "20px",
    "--font_family": "lato, sans-serif",
    "--header_color": "transparent",
    "--header_text_color": "#fff",
    "--header_boxshadow": "none",
    "--header_border": "0",
    "--header_padding": "30px 3rem",
    "--logout_icon": "logout-icon-gm.png",
    "--logout_display": 'inline-block',
    "--wlcm_display": 'flex',
    "--wlcm_display_dir": 'unset',
    "--logout_btn_border_left": "solid 2px #D7DAE0",
    "--logout_btn_border_right": 'none',
    "--logout_btn_margin_right": '10px',
    "--logout_btn_height": '30px',
    "--wlcm_label_margin": '13px 10px 0 0',
    "--wlcm_label_bg": 'transparent',
    "--wlcm_label_border": 'none',
    "--wlcm_label_display": 'contents',
    "--card_border": "0",
    "--tooltip_color": "#000",
    "--openApp_btn_fontweight": "bold",
    "--btn_position": "0",
    "--btn_transform": "none",
    "--card_bg": "rgba(255,255,255,.9)",
    "--card_h3_color": "#000",
    "--card_width": "300px",
    "--arrow_display": "inline-block",
    "--bullets_bg": "#fff",
    "--body_border": "0",
    "--card_shadow": "0 1px 22px rgba(0, 0, 0, 0.5)",
    "--card_border-radius": '0',
    "--card_padding": "0",
    "--card_height": "455px",
    "--glide-margin-top":"9% ",
    "--cards_gap": 50,
    "--card_image_height": "170px",
    "--card_image_width": "100%",
    "--card_image_position": "relative",
    "--card_image_position_top": "0",
    "--arrow_filter": "grayscale(1)",
    "--footer_color": "#fff",
    "--cookiePolicy_color": "#0078cd",
    "--arrow_image": "grey-arrow.png",
    "--card_color": "#000",
    "--page_title": "Cropwise Seed Selector",
    "--card_h3_margin": "0",
    "--card_p_margin": "0",
    "--nav_bg_color": "#fff",
    "--nav_icon": "none",
    "--nav_btn_icons": "none",
    "--nav_display": 'none',
    "--logo_display": 'initial',
    "--card_logo_display": 'initial',
    "--glide_margin": '0',
    "--nav_height": 'calc(100vh - 75px)',
    "--nav_height_mobile": 'calc(calc(var(--vh, 1vh) * 100) - 75px)',
    "--nav_position": "75px",
    "--header_zindex": '1111',
    "--header_h1_margin": '20px',
    "--nav_btn_color": "#000",
    "--breakpoints": {
      850: { perView: 3 },
      1000: { perView: 4 },
      1200: { perView: 5 },
      1500: { perView: 7 },
      2400: { perView: 15 },
      3200: { perView: 15 },
    },
    "--glide_display":"flex",
    "--slide_float":"none",
    "--glide_marginTop":"45px",
    "--card_marginLeftFirst":"0",
    "--card_marginBottom":"0",
    "--min_ind_float":"left",
    "--card_display":"block",
    "--card_flex-dir":"inherit",
    "--slide_text-height":"328px",
    "--slide_text-height-mobile":"265px",
    "--card_p_display":"1",
    "--slide_height":"500px",
    "--btn_display":"block",
    "--slide_hover_img_filter":"none",
    "--slide_hover_display":"block",
    "--bullets_keyboard":true,
    "--footer-font_weight":"normal",
    "--pages_height":"calc(var(--vh, 1vh) * 100)",
    "--body_overflow":"hidden",
    "--footer_position":"fixed",
    "--footer_position_mobile":"absolute"
  },
  theme_robseeco: {
    "--main_color": "#000",
    "--main_logo": "robseecoLogo.png",
    "--main_logo_margin":"unset",
    "--main_logo_height":"45px",
    "--frame_logo": "robseecoLogo.png",
    "--footer_logo": "robseecoLogo.png", 
    "--main_background_image": "robseeco-bg.png",
    "--button_success": "#008054",
    "--openApp_btn": "#008054",
    "--openApp_btn_text": "#FFF",
    "--openApp_btn_borderRadius": "30px",
    "--openApp_btn_position_btm": "20px",
    "--font_family": "'Open Sans', Helvetica, sans-serif",
    "--header_color": "transparent",
    "--header_boxshadow": "none",
    "--header_border": "0",
    "--header_padding": "30px 3rem",
    "--logout_icon": "logout-icon-rob.png",
    "--logout_display": 'inline-block',
    "--wlcm_display": 'flex',
    "--wlcm_display_dir": 'unset',
    "--logout_btn_border_left": "none",
    "--logout_btn_border_right": 'none',
    "--logout_btn_margin_right": '10px',
    "--logout_btn_height": '30px',
    "--wlcm_label_margin": '13px 10px 0 0',
    "--wlcm_label_bg": 'transparent',
    "--wlcm_label_border": 'none',
    "--wlcm_label_display": 'contents',
    "--card_border": "0",
    "--tooltip_color": "#000",
    "--openApp_btn_fontweight": "normal",
    "--btn_position": "50%",
    "--btn_transform": "translateX(-50%)",
    "--card_bg": "rgba(255,255,255,1)",
    "--card_h3_color": "#000",
    "--card_width": "300px",
    "--arrow_display": "none",
    "--bullets_bg": "#FFF",
    "--body_border": "0",
    "--card_shadow": " 0 1px 2px rgba(0, 0, 0, 0.07)",
    "--card_border-radius": '0',
    "--card_padding": "0",
    "--card_height": "455px",
    "--glide-margin-top":"9% ",
    "--cards_gap": 20,
    "--card_image_height": "170px",
    "--card_image_width": "100%",
    "--card_image_position": "relative",
    "--card_image_position_top": "0",
    "--footer_color": "#fff",
    "--cookiePolicy_color": "#0078cd",
    "--card_color": "#00004B",
    "--arrow_image": "",
    "--page_title": "Product Planner",
    "--card_h3_margin": "0",
    "--card_p_margin": "0",
    "--nav_bg_color": "#fff",
    "--nav_icon": "none",
    "--nav_btn_icons": "none",
    "--nav_display": 'none',
    "--logo_display": 'initial',
    "--card_logo_display": 'initial',
    "--glide_margin": '0',
    "--nav_height": 'calc(100vh - 75px)',
    "--nav_height_mobile": 'calc(calc(var(--vh, 1vh) * 100) - 75px)',
    "--nav_position": "75px",
    "--header_zindex": '1111',
    "--header_h1_margin": '20px',
    "--nav_btn_color": "#000",
    "--breakpoints": {
      850: { perView: 3 },
      1000: { perView: 4 },
      1200: { perView: 5 },
      1500: { perView: 7 },
      2400: { perView: 15 },
      3200: { perView: 15 },
    },
    "--glide_display":"flex",
    "--slide_float":"none",
    "--glide_marginTop":"45px",
    "--card_marginLeftFirst":"0",
    "--card_marginBottom":"0",
    "--min_ind_float":"left",
    "--card_display":"block",
    "--card_flex-dir":"inherit",
    "--slide_text-height":"328px",
    "--slide_text-height-mobile":"265px",
    "--card_p_display":"1",
    "--slide_height":"500px",
    "--btn_display":"block",
    "--slide_hover_img_filter":"none",
    "--slide_hover_display":"block",
    "--bullets_keyboard":true,
    "--footer-font_weight":"normal",
    "--pages_height":"calc(var(--vh, 1vh) * 100)",
    "--body_overflow":"hidden",
    "--footer_position":"fixed",
    "--footer_position_mobile":"absolute"
  }


};

module.exports = SubsectionStyles;
